import React, { useState } from 'react';
import { FaPhoneAlt, FaInstagram, FaTelegram, FaYoutube, FaBars, FaTimes } from 'react-icons/fa';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import '../MotorradHeader.css';

const MotorradHeader = () => {
    // Состояние для открытия/закрытия мобильного меню
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation(); // Переменная для определения активного роута

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Функция для перехода на страницу тест-драйва
    const handleTestDriveClick = () => {
        setIsMenuOpen(false); 
        navigate('/test-drive'); 
    };

    return (
        <header className="motorrad-header">
            {/* 1. Верхняя панель (Контакты и соцсети) */}
            <div className="top-bar">
                <div className="top-bar-container">
                    <div className="top-left"> 
                        <a href="tel:++998555018877"><FaPhoneAlt /> Телефон: +998 55 501 88 77 </a>
                    </div>
                    <div className="top-right">
                        <div className="social-links">
                            <a href="https://www.instagram.com/bmwmotorraduz/"><FaInstagram /></a>
                            <a href="https://t.me/bmwuzpa"><FaTelegram /></a>
                            <a href="https://www.youtube.com/@BMWUzbekistanPA"><FaYoutube /></a>
                        </div>
                        <div className="language-selector">
                            Язык: <span>RU</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* 2. Основное меню навигации */}
            <nav className="main-nav">
                <div className="nav-container">
                    
                    {/* Кнопка бургера — появляется только на мобильных устройствах */}
                    <button className="burger-menu-btn" onClick={toggleMenu} aria-label="Открыть меню">
                        {isMenuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                    {/* Десктопное меню */}
                    <ul className="nav-menu">
                        <li><Link to="/" style={{textDecoration: 'none', color: 'inherit'}}>Главная</Link></li>
                        
                        <li><Link to="/moto_models" style={{textDecoration: 'none', color: 'inherit'}}>Модели</Link></li> {/* <span className="arrow">⌄</span> */}
                        <li><Link to="/service-request" style={{textDecoration: 'none', color: 'inherit'}}>Владельцам</Link></li>{ /* <span className="arrow">⌄</span> */} 
                        
                        {/* Ссылка на страницу контактов */}
                        <li className={location.pathname === '/contacts' ? 'active-link' : ''}>
                            <Link to="/contacts" style={{textDecoration: 'none', color: 'inherit'}}>Контакты</Link>
                        </li>
                        
                        <li onClick={handleTestDriveClick} className="nav-highlight-btn">Записаться на тест-драйв</li>
                    </ul>

                    {/* Логотипы */}
                    <div className="nav-logos">
                        <Link to="/motorrad">
                            <img src="/assets/BMW MOTORRAD LOGO BLACK2.svg" alt="BMW Motorrad" className="logo-motorrad" />
                        </Link>
                    </div>
                </div>
            </nav>

            {/* 3. Выпадающее мобильное меню (Бургер-шторка) */}
            <div className={`mobile-overlay-menu ${isMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-content">
                    
                    <ul className="mobile-nav-links">
                        <li>
                            <Link to="/" onClick={toggleMenu}>Главная</Link>
                        </li>
                        <li>
                            <Link to="/moto_models" onClick={toggleMenu}>Модели</Link>
                        </li>
                        <li>
                            <Link to="/service-request" onClick={toggleMenu}>Владельцам</Link>
                        </li>
                        
                        {/* Кнопка тест-драйва */}
                        <li onClick={handleTestDriveClick} style={{color: '#1c69d4', fontWeight: 'bold'}}>Записаться на тест-драйв</li>
                        
                        {/* Переход на контакты в мобильной шторке */}
                        <li>
                            <Link to="/contacts" onClick={toggleMenu}>Контакты</Link>
                        </li>
                    </ul>

                    <div className="mobile-menu-divider"></div>

                    <div className="mobile-menu-phone">
                        <a href="tel:++998555018877"><FaPhoneAlt /> Телефон: +998 55 501 88 77 </a>
                    </div>

                    <div className="mobile-menu-socials">
                        <a href="https://www.instagram.com/bmwmotorraduz/"><FaInstagram /></a>
                        <a href="https://t.me/bmwuzpa"><FaTelegram /></a>
                        <a href="https://www.youtube.com/@BMWUzbekistanPA"><FaYoutube /></a>
                    </div>

                    <div className="mobile-menu-lang">
                        Язык: <span>RU</span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default MotorradHeader;